import defaultAttributes from '../defaultAttributes';

const Power = [
  'svg',
  defaultAttributes,
  [
    ['path', { d: 'M18.36 6.64a9 9 0 11-12.73 0' }],
    ['line', { x1: '12', y1: '2', x2: '12', y2: '12' }],
  ],
];

export default Power;
